var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.75006V9.68756",
    stroke: "white",
    strokeWidth: 0.762094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.751 4.23444C14.9931 5.04283 15.9408 6.23098 16.4528 7.6218C16.9647 9.01262 17.0135 10.5316 16.5919 11.9525C16.1703 13.3733 15.3008 14.6198 14.1131 15.5063C12.9254 16.3927 11.483 16.8717 10.001 16.8717C8.51893 16.8717 7.07655 16.3927 5.88884 15.5063C4.70112 14.6198 3.83166 13.3733 3.41004 11.9525C2.98843 10.5316 3.03723 9.01262 3.54918 7.6218C4.06113 6.23098 5.00881 5.04283 6.25098 4.23444",
    stroke: "white",
    strokeWidth: 0.762094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.af6e4fae257882bb12785c24d399b78d.svg";
export { ForwardRef as ReactComponent };